var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-file-picture",
    "data-name": "Icon metro-file-picture",
    d: "M26.784,28.178H8.213v-3.75l5.571-9.375,7.632,9.375,5.368-3.75Zm0-12.188A2.786,2.786,0,1,1,24,13.178,2.8,2.8,0,0,1,26.784,15.991Zm2.49-7.351a26.492,26.492,0,0,0-2.53-2.921,26.4,26.4,0,0,0-2.893-2.554c-1.5-1.108-2.223-1.236-2.638-1.236H6.82A2.335,2.335,0,0,0,4.5,4.272V29.584A2.335,2.335,0,0,0,6.82,31.928H28.177A2.335,2.335,0,0,0,30.5,29.584V11.3c0-.42-.127-1.153-1.224-2.664Zm-3.843-1.6a25.494,25.494,0,0,1,2.106,2.384H23.07V4.918a25.382,25.382,0,0,1,2.361,2.126Zm3.21,22.54a.473.473,0,0,1-.464.469H6.82a.473.473,0,0,1-.464-.469V4.272A.473.473,0,0,1,6.82,3.8H21.213v6.562a.933.933,0,0,0,.929.938h6.5Z",
    transform: "translate(-4.499 -1.928)",
    fill: "#6c9efc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/DefaultImage.024476cc5d28ccb798b84783d475dd8c.svg";
export { ForwardRef as ReactComponent };